export const CART_STORAGE_KEY = 'cart';
export const CHECKOUT_IDEMPOTENCY_KEY = 'checkout_idempotency_key';
export const VAT_RATE = 0.23;
export const SOIL_BAGS_PRODUCT_CODE = 'soil_bags';
export const SHIPPING_PRODUCT_CODE = 'shipping_fixed';
